// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["pane"]

  connect() {
    console.log("Toggler connected")
    this.paneTarget.hidden = true;
  }

  toggle(e) { 
    console.log("Toggler toggling", this.paneTarget)
    this.paneTarget.hidden = ! this.paneTarget.hidden
    console.log("done")
  }
}
